/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/naming-convention */
import { AppVariables } from '@shared';
import { RxJsonSchema } from 'rxdb';

export class RefTableSchemaBuilder {
	private jsonSchema: RxJsonSchema<any> = {
		primaryKey: 'rxdbidstring',
		version: 0,
		properties: {},
		type: 'object',
		description: 'This is dynamically Build'
	};

	/* eslint-disable @typescript-eslint/no-unused-vars */
	public addRefTableProperty(name: string, type: string): RefTableSchemaBuilder {
		this.jsonSchema.properties[name] = {
			type: ['string', 'number', 'null']
		};
		return this;
	}

	public build(): RxJsonSchema<any> {
		// // todo: fix this
		this.jsonSchema.properties['rxdbidstring'] = {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		};

		return this.jsonSchema;
	}
}
